import tw from "tailwind-styled-components";
import { BoxHead, Underline } from "../../Styles/PageStyles";
import { ownership_roles } from "../../../Config";
import { AddBtn } from "../../Styles/InputStyles";
import { useState } from "react";
import AddLandlordLeaseDetail from "../Lease/AddLeaseDetails";
import SideModal from "../../SideModal";
import { MdEdit } from "react-icons/md";

export default function LeaseDetails({
  landlordData,
  apiData,
  setShowAddLeaseModel,
  setShowEditLeaseModel,
}) {
  const formatDate = (date) => {
    if (!date) return "-";
    try {
      return new Date(date).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch {
      return "-";
    }
  };

  const formatCurrency = (val) => {
    if (!val && val !== 0) return "-";
    return `₹${Number(val).toLocaleString("en-IN")}`;
  };
  const getRentCollectionTypeText = (collectionType) => {
    switch (collectionType) {
      case 1:
        return "Advance Rent";
      case 2:
        return "Month-End Rent";
      default:
        return "--";
    }
  };
  const hasLease = (() => {
  const lease = apiData?.lease;

  if (Array.isArray(lease)) return lease.length > 0;
  if (typeof lease === "object" && lease !== null) return !!lease.id;

  return false;
})();
//   const hasLease = !!apiData?.lease;
  return (
    <Wrapper>
      <BoxHead>
        <Title className="!mb-0">
          Landlord & Lease Details
          <Underline />
        </Title>
        {/* <AddBtn
                    type="button"
                    className="text-sm  w-24  md:w-20 h-7 md:text-xs"
                >
                    Add Lease
                </AddBtn> */}
      </BoxHead>
      {/* <SubmitBtn type="submit" disabled={editPropBasicInfoLoading} className="text-sm  w-24  md:w-20 h-7 md:text-xs">
                {editPropBasicInfoLoading ? "Loading..." : "Update"}
              </SubmitBtn> */}
      {/* MAIN GRID */}

      <Grid>
        {/* ---------------- LANDLORD INFO ---------------- */}
        <Card>
          <SectionTitle>Landlord/Broker Information</SectionTitle>

          <Row>
            <Label>Name</Label>
            <Value>{apiData?.belongsToName || "-"}</Value>
          </Row>

          <Row>
            <Label>Mobile</Label>
            <Value>{apiData?.belongsToMobile || "-"}</Value>
          </Row>

          <Row>
            <Label>Alt Mobile</Label>
            <Value>{apiData?.belongsToAlternateMobile || "-"}</Value>
          </Row>
          {/* <Row>
            <Label>Ownership</Label>
            <Value>
              {ownership_roles.find((r) => r.value === apiData?.ownershipType)
                ?.label || "-"}
            </Value>
          </Row> */}
          <Row>
            <Label>Email</Label>
            <Value>{apiData?.belongsToEmail || "-"}</Value>
          </Row>

          <Divider />

          <SectionTitle>Landlord Rent Summary</SectionTitle>

          <Row>
            <Label>Current Month Paid</Label>
            <Value>{formatCurrency(apiData?.curMonthRentPaid)}</Value>
          </Row>

          <Row>
            <Label>Pending Rent</Label>
            <Pending>{formatCurrency(landlordData?.rentPending)}</Pending>
          </Row>

          <Row>
            <Label>Total Rent To Be Paid</Label>
            <Highlight>
              {formatCurrency(landlordData?.totalRentToBePaid)}
            </Highlight>
          </Row>
        </Card>
        {/* ---------------- LEASE DETAILS ---------------- */}
        <Card>
          <CardHeader>
            <SectionTitle>Lease Information</SectionTitle>
            {/* <button
              type="button"
              className="text-sm font-semibold text-primary-color hover:underline mb-3"
              onClick={() => setShowAddLeaseModel(true)}

            >
              + Add Lease
            </button> */}
            <button
              type="button"
              className="flex items-center gap-1 text-sm font-semibold text-primary-color hover:underline mb-3"
              onClick={() => {
                if (hasLease) {
                    setShowEditLeaseModel(true);
                } else {
                  setShowAddLeaseModel(true);
                }
              }}
            >
              {hasLease ? (
                <>
                  <MdEdit className="" size={13} />
                  Edit Lease
                </>
              ) : (
                "+ Add Lease"
              )}
            </button>
          </CardHeader>
          <Row>
            <Label>Rent</Label>
            <Highlight>{formatCurrency(apiData?.lease?.rent)}</Highlight>
          </Row>
          <Row>
            <Label>Collection Type</Label>
            <Highlight>
              {" "}
              {getRentCollectionTypeText(
                apiData?.lease?.rentCollectionType || "-",
              )}
            </Highlight>
          </Row>

          <Row>
            <Label>Security Deposit</Label>
            <Value>{formatCurrency(apiData?.lease?.security)}</Value>
          </Row>
          <Row>
            <Label>Lease Period</Label>
            <Value>
              {formatDate(apiData?.lease?.startDate)} —{" "}
              {formatDate(apiData?.lease?.endDate)}
            </Value>
          </Row>

          <Row>
            <Label>Lock-in Period</Label>
            <Value>{apiData?.lease?.lockInPeriod} Months</Value>
          </Row>

          <Row>
            <Label>Notice Period</Label>
            <Value>{apiData?.lease?.notice} Months</Value>
          </Row>

          <Row>
            <Label>Rent Date</Label>
            <Value>{formatDate(apiData?.lease?.rentDate)}</Value>
          </Row>
          <Row>
            <Label>Increment</Label>
            <Highlight>
              {" "}
              {apiData?.lease?.incrementType === 2
                ? apiData?.lease?.incrementValue + "%"
                : apiData?.lease?.incrementType === 1
                  ? "₹" + apiData?.lease?.incrementValue
                  : "-"}
            </Highlight>
          </Row>
          <Row>
            <Label>Increment Month</Label>
            <Highlight>
              {" "}
              {apiData?.lease?.incrementMonth
                ? `${apiData?.lease?.incrementMonth} month${
                    apiData?.lease?.incrementMonth > 1 ? "s" : ""
                  }`
                : "--"}
            </Highlight>
          </Row>
        </Card>
      </Grid>
    </Wrapper>
  );
}

/* ---------------- STYLES ---------------- */

const Wrapper = tw.div`px-4 mt-2 space-y-4`;

const Grid = tw.div`
grid grid-cols-1 lg:grid-cols-2 gap-6
`;

const Card = tw.div`
bg-white border border-gray-200 rounded-xl p-5 shadow-sm
`;

const Row = tw.div`
flex justify-between items-start py-2 border-b border-gray-100 last:border-none
`;

const Label = tw.span`
text-sm text-gray-500
`;

const Value = tw.span`
text-sm text-gray-800 font-medium text-right
`;

const Highlight = tw.span`
text-base font-semibold text-blue-500 text-right
`;

const Pending = tw.span`
text-sm font-semibold text-red-500 text-right
`;

const SectionTitle = tw.h3`
text-sm font-semibold text-gray-700 mb-3
`;

const Divider = tw.div`my-4 border-t border-gray-200`;

const Title = tw.h2`
text-lg text-black font-semibold space-x-2 items-center mb-5 rounded-md
`;
const CardHeader = tw.div`
  flex justify-between items-center
`;
